import { get as lodashGet, has as lodashHas, merge as lodashMerge } from 'lodash';
import { assign, AssignMeta } from 'xstate';
import { AppStateMachineContext, AppStateMachineEvent } from '../types';

export type MergeAction = {
  action: {
    params: {
      defaultsName: string;
    };
  };
} & AssignMeta<AppStateMachineContext, AppStateMachineEvent>;

const isActionDefaultsMeta = (
  metaObj: AssignMeta<AppStateMachineContext, AppStateMachineEvent>,
): metaObj is MergeAction => lodashHas(metaObj, 'action.params.defaultsName');

const isContextHasDefaults = (
  context: AppStateMachineContext,
  name: string,
): boolean => lodashHas(context.digitalSubmissionDefaults, name);

export const assignAction = (
  context: AppStateMachineContext,
  meta: AssignMeta<AppStateMachineContext, AppStateMachineEvent>,
) => {
  if (isActionDefaultsMeta(meta) && isContextHasDefaults(context, meta.action.params.defaultsName)) {
    const { digitalSubmission } = context;
    const mergedDigitalSubmission = lodashMerge(
      digitalSubmission, lodashGet(context.digitalSubmissionDefaults, meta.action.params.defaultsName),
    );

    return { digitalSubmission: mergedDigitalSubmission };
  }

  return context;
};

export const copySubmissionDefaults = assign<
AppStateMachineContext, AppStateMachineEvent
>((context, _event, meta) => assignAction(context, meta));
